import React, { createContext, useContext, useEffect, useState } from 'react';
import { Server_URL, scenarios_URL } from '../constants/constants';

const ScenariosContext = createContext();

export function ScenariosProvider({ children }) {
  const [scenarios, setScenarios] = useState([]);
  const [loadingScenario, setLoading] = useState(true);
  const [errorScenario, setError] = useState('');
    
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');
        const response = await fetch(`${Server_URL}${scenarios_URL}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await response.json();
        setScenarios(data);
      } catch (err) {
        setError('Failed to fetch scenarios');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <ScenariosContext.Provider value={{ scenarios, loadingScenario, errorScenario }}>
      {children}
    </ScenariosContext.Provider>
  );
}

export function useScenarios() {
  return useContext(ScenariosContext);
}